import { isPromise } from '../async/isPromise.js'

export function toJSON(parameters: object, space?: number): string {
  return JSON.stringify(
    parameters,
    (_k, v: unknown) => {
      if (typeof v === 'bigint') {
        return v.toString()
      }

      if (isPromise(v)) {
        return 'Promise'
      }

      return v
    },
    space,
  )
}
